import { FaroText, FontWeights, green, red } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import { memo, type JSX } from "react";

type StatusChipVariant = "approved" | "rejected";

type AiAssetReviewStatusChipProps = {
  /** The text label to display */
  label: string;
  /** The variant determining the color scheme */
  variant: StatusChipVariant;
};

/** @returns custom status chip component with Faro UI styling */
export const AiAssetReviewStatusChip = memo(function AiAssetReviewStatusChip({
  label,
  variant,
}: AiAssetReviewStatusChipProps): JSX.Element {
  const isApproved = variant === "approved";

  return (
    <Box
      component="div"
      sx={{
        px: 1,
        borderRadius: 24,
        backgroundColor: isApproved ? green[50] : red[50],
        border: 1,
        borderColor: isApproved ? green[100] : red[100],
        py: 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FaroText
        variant="bodyXS"
        sx={{
          color: isApproved ? green[700] : red[700],
          fontWeight: FontWeights.Bold,
          textTransform: "uppercase",
        }}
      >
        {label}
      </FaroText>
    </Box>
  );
});
